import { Fragment, useEffect, useState } from 'react'
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { ErrorMessage, Field, Formik } from 'formik'
import * as yup from 'yup'
import { CustomButton } from 'modules/auth/styles'
import UserMultiSelect from 'modules/app/components/UserMultiSelect'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { ReactComponent as TrashIcon } from 'assets/images/icons/trash.svg'
import { ButtonLoader, getDefaultSharingOnEdit } from 'utils/storageUtils'
import { ModalForm } from 'modules/app/styles'
import { connect } from 'react-redux'
import { getAllTeams, getCompanyPermissionObject, getTeamPermissionObject, handleApiError, logAmplitudeEvent, RESTRICTED_CATEGORY_NAMES, sharing_access } from 'utils/helpers'
import { ReactComponent as ChevronRightIcon } from 'assets/images/editor-icons/chevron_right.svg'
import { getCategories_action, saveCategory_action, toggleCategoryModal_action, toggleDeleteCategoryModal_action } from 'store/actions'
import { categorySharing_api, getCategorybyId_api } from 'store/apis'
import { toast } from 'react-toastify'
import { history } from 'store/store'
import { Breadcrumbs } from 'modules/pages/styles'

export function CategoryModal(props) {
  const {
    user,
    contents: { showCategoryModal, editingCategory },
    company,
    teams
  } = props
  const [options, set_options] = useState([])
  const [is_submitting, set_is_submitting] = useState(false)
  const [saved, set_saved] = useState(false)
  const [is_loading, set_is_loading] = useState(false)
  const [category, set_category] = useState({ user: {} })
  const [breadbrumb, set_breadbrumb] = useState([])

  // Autofocus
  useEffect(() => {
    setTimeout(() => {
      const CATEGORY_TITLE = document.getElementById('categoryTitle')
      if (CATEGORY_TITLE) CATEGORY_TITLE.focus()
    }, 250)
  }, [])

  const getCategory = async (uuid) => {
    try {
      set_is_loading(true)
      const category = await getCategorybyId_api(uuid)
      if (category.id) {
        set_category((data) => ({ ...category, shared_users: !category.parent_id ? category.shared_users : data.shared_users }))
      }
    } catch (error) {}
    set_is_loading(false)
  }
  const getRootCategory = async (uuid) => {
    try {
      // set_is_loading(true)
      const parent_category = await getCategorybyId_api(uuid)
      if (parent_category.id) {
        set_category((data) => ({ ...data, parent_id: parent_category.id, shared_users: parent_category.shared_users }))
      }
    } catch (error) {}
    set_is_loading(false)
  }
  useEffect(() => {
    if (editingCategory.id) {
      // to update category
      getCategory(editingCategory.uuid)
    } else {
      // to create category
      set_category((data) => ({ ...data, parent_id: editingCategory.parent_id || '', user: { ...user, user_id: user.id, value: user.member_code, option_type: 'user' } }))
    }

    // get root category shared_users
    if (editingCategory.root_category) {
      getRootCategory(editingCategory.root_category.uuid)
      const _breadcrumb = [editingCategory.root_category]
      if (editingCategory.parent_category && editingCategory.parent_category.id !== editingCategory.root_category.id) {
        _breadcrumb.push(editingCategory.parent_category)
      }
      set_breadbrumb(_breadcrumb)
    }

    // If creating or sub category, fetch owners and viewers of the parent category
  }, [editingCategory, user, company.company])

  // Company options:
  useEffect(() => {
    if (!company.loading && company.company.id) {
      set_options((data) => [...data, getCompanyPermissionObject(company.company)])
    }
  }, [company.loading, company.company])

  // Team options:
  useEffect(() => {
    const all_teams = getAllTeams(teams)
    set_options((data) => [...data, ...getTeamPermissionObject(all_teams)])
  }, [teams])

  return (
    <Modal centered fade={false} isOpen={showCategoryModal}>
      {!is_loading && (
        <Formik
          enableReinitialize
          initialValues={{
            id: category.id || null,
            name: category.name || '',
            parent_id: category.parent_id,
            type: category.type,
            owners: [
              editingCategory.root_category
                ? { ...editingCategory.root_category.user, value: editingCategory.root_category.user.member_code, option_type: 'user', isFixed: true }
                : { ...category.user, user_id: category.user_id, value: category.user.member_code, option_type: 'user', isFixed: true },
              ...getDefaultSharingOnEdit(sharing_access.owner, category)
            ],
            editors: getDefaultSharingOnEdit(sharing_access.editor, {
              ...category,
              shared_users: category.id ? category.shared_users : []
            }),
            viewers: getDefaultSharingOnEdit(sharing_access.viewer, category)
          }}
          validationSchema={yup.object().shape({
            name: yup
              .string()
              .trim()
              .lowercase()
              .notOneOf(RESTRICTED_CATEGORY_NAMES, `Choose category name other than "${RESTRICTED_CATEGORY_NAMES.join().replaceAll(`,`, `", "`)}"`)
              .required()
            // owners: category.parent_id ? [] : yup.array().min(1)
          })}
          onSubmit={async (values) => {
            try {
              set_is_submitting(true)

              let _category = { ...values }
              // if (_category.owners.length + _category.editors.length + _category.viewers.length < 2) {
              //   // eslint-disable-next-line no-throw-literal
              //   throw { _errors: ['Select atlest one owner or editor or viewer'] }
              // }

              // Create/Update category if not exists
              const category_data = { type: editingCategory.type, uuid: editingCategory.uuid, name: _category.name, parent_id: editingCategory.parent_id }
              const create_result = await props.saveCategory(category_data)
              _category.id = create_result.id
              _category.uuid = create_result.uuid
              _category.type = create_result.type

              // Update sharing only for root category
              let is_shared = false
              if (!category.parent_id) {
                const owners = values.owners.map((u) => {
                  u.access = sharing_access.owner
                  return u
                })
                const viewers = values.viewers.map((u) => {
                  u.access = sharing_access.viewer
                  return u
                })
                const editors = values.editors.map((u) => {
                  u.access = sharing_access.editor
                  return u
                })
                const sharings = [...owners, ...editors, ...viewers]
                const shared_everyone = JSON.stringify(sharings.filter((c) => c.option_type === 'company').map((c) => ({ access: c.access })))
                const shared_teams = JSON.stringify(sharings.filter((c) => c.option_type === 'team').map((c) => ({ id: c.team_id, access: c.access })))
                const shared_users = JSON.stringify(sharings.filter((c) => c.option_type === 'user' && c.user_id !== editingCategory.user_id).map((c) => ({ id: c.user_id, access: c.access })))

                const data = {
                  category_id: _category.id,
                  shared_everyone,
                  shared_teams,
                  shared_users
                }
                await categorySharing_api(data)
                is_shared = true
              }
              if (editingCategory.id) {
                toast.success('Category updated')
              } else {
                toast.success('New Category created')
                if (category_data.type === 'page') {
                  if (is_shared) {
                    logAmplitudeEvent('Page category created - Shared')
                  } else {
                    logAmplitudeEvent('Page category created - Private')
                  }
                } else if (category_data.type === 'response') {
                  if (is_shared) {
                    logAmplitudeEvent('Response category created - Shared')
                  } else {
                    logAmplitudeEvent('Response category created - Private')
                  }
                }
              }
              set_saved(true)
              props.getCategories()
              setTimeout(() => {
                set_saved(false)
                props.toggleCategoryModal(false)
                if (!history?.location?.pathname.includes('/page/category')) {
                  let redirectURI = ''
                  if (!editingCategory.root_category && !editingCategory.parent_category) {
                    // Create/Edit Root Category
                    redirectURI = `${_category.uuid}`
                  } else if (editingCategory.parent_category.id === editingCategory.root_category.id) {
                    // Create/Edit Sub-category
                    redirectURI = `${editingCategory.parent_category.uuid}/${_category.uuid}`
                  } else if (editingCategory.root_category.id !== editingCategory.parent_category.id) {
                    // Create/Edit Sub-sub-category
                    redirectURI = `${editingCategory.root_category.uuid}/${editingCategory.parent_category.uuid}/${_category.uuid}`
                  }
                  if (redirectURI) {
                    redirectURI = `/${_category.type}/category/${redirectURI}`
                    history.push(redirectURI)
                  }
                }
              }, 2000)
            } catch (error) {
              error && handleApiError(error)
            }
            set_is_submitting(false)
          }}>
          {(formikProps) => (
            <ModalForm onSubmit={formikProps.handleSubmit} autoComplete='off'>
              <ModalBody className='pb-3'>
                <a
                  href='/'
                  className='modal-close'
                  onClick={(e) => {
                    e.preventDefault()
                    props.toggleCategoryModal(false)
                  }}>
                  <CloseIcon />
                </a>

                {/* Parent Category */}
                <Breadcrumbs className='mb-5'>
                  {breadbrumb.length === 0 && <span>Main Category</span>}
                  {breadbrumb.map((cat, i) => (
                    <span key={cat.id}>
                      {cat.name}
                      &nbsp;
                      {breadbrumb.length === i + 1 ? '' : <ChevronRightIcon />}
                      &nbsp;
                    </span>
                  ))}
                </Breadcrumbs>

                <Field name='name'>
                  {({ field }) => (
                    <FormGroup className={`${!editingCategory.parent_id ? 'mb-5' : ''}`}>
                      <Input {...field} id='categoryTitle' className={`${formikProps.errors.name ? 'error' : ''} ${field.value ? 'has-value' : ''}`} />
                      <Label htmlFor='categoryTitle'>Title</Label>
                      <ErrorMessage name='name' className='error-message' component='div' />
                    </FormGroup>
                  )}
                </Field>

                {!editingCategory.parent_id && (
                  <Fragment>
                    <FormGroup className='mb-5'>
                      <Label>Owners: </Label>
                      <UserMultiSelect
                        name='owners'
                        isDisabled={formikProps.values.parent_id}
                        options={options}
                        defaultValue={formikProps.values.owners}
                        onChange={(value) => formikProps.setFieldValue('owners', value)}
                        user={user}
                        hidden={[...formikProps.values.viewers, ...formikProps.values.editors]}
                      />
                      <div className='text-muted'>
                        <small>Owners can edit and add subcategories and delete category</small>
                      </div>
                    </FormGroup>

                    <FormGroup className='mb-5'>
                      <Label>Editors: </Label>
                      <UserMultiSelect
                        name='editors'
                        isDisabled={formikProps.values.parent_id}
                        options={options}
                        defaultValue={formikProps.values.editors}
                        onChange={(value) => formikProps.setFieldValue('editors', value)}
                        user={user}
                        hidden={[...formikProps.values.viewers, ...formikProps.values.owners]}
                      />
                      <div className='text-muted'>
                        <small>Category editors can edit and publish {editingCategory.type}s in a category</small>
                      </div>
                    </FormGroup>

                    <FormGroup className='mb-5'>
                      <Label>Viewers: </Label>
                      <UserMultiSelect
                        name='viewers'
                        isDisabled={formikProps.values.parent_id}
                        options={options}
                        defaultValue={formikProps.values.viewers}
                        onChange={(value) => formikProps.setFieldValue('viewers', value)}
                        user={user}
                        hidden={[...formikProps.values.owners, ...formikProps.values.editors]}
                      />
                      <div className='text-muted'>
                        <small>Category viewers can comment on and view every {editingCategory.type} in a category</small>
                      </div>
                    </FormGroup>
                  </Fragment>
                )}
                <div className='px-2 py-2 light-blue-100-opacity text-center mr-auto'>Admins have the same access as owners always</div>
              </ModalBody>
              <ModalFooter className='d-flex justify-content-between'>
                <div className='px-3'></div>
                <div>
                  <CustomButton type='submit' className={`mx-5 ${!saved ? 'black' : 'green'}`} disabled={is_submitting || saved || !formikProps.isValid}>
                    {saved ? (category.id ? 'Updated' : 'Created') : category.id ? 'Update' : 'Create'}
                    {is_submitting && <ButtonLoader />}
                  </CustomButton>
                </div>
                <div>
                  {editingCategory.id && (
                    <CustomButton type='button' className='gray px-2' onClick={() => props.toggleDeleteCategoryModal(true, category)}>
                      <TrashIcon style={{ width: 18, height: 18 }} />
                    </CustomButton>
                  )}
                </div>
              </ModalFooter>
            </ModalForm>
          )}
        </Formik>
      )}
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  contents: state.contents,
  company: state.company,
  teams: state.teams
})

const mapDispatchToProps = (dispatch) => ({
  toggleCategoryModal: (status) => dispatch(toggleCategoryModal_action(status)),
  toggleDeleteCategoryModal: (status, item, redirectToHome) => dispatch(toggleDeleteCategoryModal_action(status, item, redirectToHome)),
  saveCategory: (data) => new Promise((resolve, reject) => dispatch(saveCategory_action(data, resolve, reject))),
  getCategories: () => dispatch(getCategories_action()),
})
export default connect(mapStateToProps, mapDispatchToProps)(CategoryModal)
